import { StatesModule } from '@uirouter/angular';
import { Transition } from '@uirouter/core';
import { AiChatbotComponent } from './components/ai-chatbot/ai-chatbot.component';
import { CompanyStateService } from '../auth/services/company-state.service';
import { UserStateService } from '../auth/services/user-state.service';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.chat',
      url: '/chat',
      component: AiChatbotComponent,
      resolve: [
        {
          token: 'canAccessAps',
          deps: [Transition, UserStateService, CompanyStateService],
          resolveFn: (
            transition: Transition,
            userState: UserStateService,
            companyStateService: CompanyStateService,
          ) => {
            if (
              !(
                userState.isRiseAdmin() ||
                companyStateService.getCopyOfSelectedCompany().settings
                  ?.aiEnabled
              )
            ) {
              console.log(
                'User is not an admin, AI chatbot is not enabled for this company, redirecting to home',
              );
              transition.abort();
              return transition.router.stateService.go('apps.home');
            }
          },
        },
      ],
    },
  ],
};
